import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function LoginForm() {
  const { t } = useTranslation();
  const email = useAuth(s => s.email);
  const password = useAuth(s => s.password);
  const authLoading = useAuth(s => s.authLoading);
  const authError = useAuth(s => s.authError);
  const setEmail = useAuth(s => s.setEmail);
  const setPassword = useAuth(s => s.setPassword);
  const setAuthView = useAuth(s => s.setAuthView);
  const resetAuthForm = useAuth(s => s.resetAuthForm);
  const handleLogin = useAuth(s => s.handleLogin);

  const onSubmit = (e: React.FormEvent) => { e.preventDefault(); handleLogin(); };

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder={t('storeSettings.email')}
        required
        autoComplete="email"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <input
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        placeholder={t('storeSettings.password')}
        required
        autoComplete="current-password"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {authError && <p className="text-sm text-red-600">{authError}</p>}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={authLoading || !email.trim() || !password}
          className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {authLoading ? t('storeSettings.loggingIn') : t('storeSettings.login')}
        </button>
        <button
          type="button"
          onClick={() => { setAuthView(null); resetAuthForm(); }}
          className="rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50"
        >
          {t('common.cancel')}
        </button>
      </div>
      <div className="flex justify-between text-xs pt-1">
        <button
          type="button"
          onClick={() => { setAuthView('register'); resetAuthForm(); }}
          className="text-blue-600 hover:underline"
        >
          {t('storeSettings.register')}
        </button>
        <button
          type="button"
          onClick={() => { setAuthView('forgot'); resetAuthForm(); }}
          className="text-blue-600 hover:underline"
        >
          {t('storeSettings.forgotPassword')}
        </button>
      </div>
    </form>
  );
}
